import React from 'react';
import './Navbar.css';

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <a href="/">IMPORTACIONES 🛍️</a>
      </div>
      <ul className="navbar-links">
        <li><a href="/mujer">Mujer</a></li>
        <li><a href="/hombre">Hombre</a></li>
        <li><a href="/accesorios">Accesorios</a></li>
        <li><a href="/contacto">Contacto</a></li>
      </ul>
    </nav>
  );
};

export default Navbar;